module.exports = __webpack_public_path__ + "img/helpful-hints-icon.a5a5f53b.svg";